import React from 'react';

const ItemListIcon = ({ size = '25px', color = '#fff' }) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 208.000000 208.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,208.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M970 2073 c-41 -8 -109 -61 -132 -103 l-23 -40 -85 0 c-54 0 -91 -5
-98 -12 -7 -7 -12 -33 -12 -59 l0 -47 -123 -3 c-117 -4 -126 -6 -172 -34 -36
-22 -57 -45 -77 -84 l-28 -53 0 -740 c0 -809 -3 -773 58 -834 63 -62 26 -59
727 -62 352 -2 659 0 681 3 53 7 112 46 144 93 l25 37 0 760 0 760 -28 47
c-18 31 -44 57 -75 75 -43 26 -57 28 -169 32 l-123 3 0 47 c0 26 -5 52 -12 59
-8 8 -45 12 -100 12 -87 0 -88 0 -103 30 -19 37 -58 76 -96 95 -31 17 -137 27
-179 18z m113 -97 c39 -16 61 -40 90 -97 l22 -44 83 -3 82 -3 0 -94 0 -95
-320 0 -320 0 0 95 0 95 73 0 c81 0 92 7 117 68 18 47 73 86 128 91 7 0 27 -5
45 -13z m-463 -340 c0 -113 -26 -106 415 -106 278 0 376 3 395 13 23 11 25 19
28 90 l3 77 100 0 c120 0 164 -16 185 -66 11 -27 14 -164 14 -748 0 -431 -4
-725 -10 -740 -21 -57 -11 -56 -710 -56 -699 0 -689 -1 -710 56 -6 15 -10 309
-10 740 0 583 3 721 14 747 21 51 63 67 184 67 l102 0 0 -74z'
        />
        <path
          d='M706 1300 l-82 -80 -35 36 c-50 52 -66 58 -95 39 -13 -8 -24 -25 -24
-36 0 -26 126 -159 150 -159 19 0 36 14 158 133 82 79 97 108 70 135 -28 28
-60 13 -142 -68z'
        />
        <path
          d='M958 1249 c-25 -14 -22 -55 4 -73 19 -14 66 -16 314 -16 272 0 293 1
315 19 20 16 22 23 14 47 l-10 29 -310 2 c-198 2 -316 -1 -327 -8z'
        />
        <path
          d='M708 908 l-88 -81 -45 42 c-24 22 -51 41 -59 41 -20 0 -46 -28 -46
-49 0 -19 115 -145 141 -154 21 -7 20 -7 143 107 87 80 106 103 106 127 0 28
-23 50 -52 49 -7 -1 -52 -37 -100 -82z'
        />
        <path
          d='M962 854 c-24 -17 -29 -53 -10 -72 9 -9 94 -12 321 -12 283 0 311 1
323 18 20 25 17 49 -8 66 -19 14 -66 16 -313 16 -247 0 -294 -2 -313 -16z'
        />
        <path
          d='M707 511 l-82 -80 -40 40 c-42 40 -80 50 -103 27 -25 -25 -11 -54 58
-123 62 -62 72 -68 94 -60 13 6 70 54 125 107 102 97 118 127 89 156 -27 27
-59 12 -141 -67z'
        />
        <path
          d='M957 452 c-23 -25 -21 -48 5 -66 33 -24 593 -24 626 0 27 18 28 45 4
67 -16 15 -53 17 -319 17 -278 0 -301 -1 -316 -18z'
        />
      </g>
    </svg>
  );
};

export default ItemListIcon;
